require('./bootstrap');
import Swiper, { Navigation } from 'swiper';
import hamburger from './hamburger';
import tabs from './tabs';
import formFilter from './form-filter';

Swiper.use([Navigation]);

console.log('app');

hamburger.init();

if (document.getElementById('form-filter')) {
	formFilter.init();
}

if (document.getElementsByClassName('accordion').length) {
	tabs.init();
}

window.addEventListener('scroll', () => {
	const currentScroll = window.pageYOffset;

	if (currentScroll <= 0) {
		document.getElementById('navbar').classList.remove('is-scrolling');
		return;
	}

	document.getElementById('navbar').classList.add('is-scrolling');
});

const swiperImages = new Swiper('.slider-images.swiper-container', {
	// init: false,
	navigation: {
		nextEl: '.slider-nav-next',
		prevEl: '.slider-nav-prev',
	},
	on: {
		init: function() {
			const numberOfSlides = this.slides.length;
			console.log(numberOfSlides);
			// if (numberOfSlides > 1) {
			// 	this.init();
			// }
		}
	}
});

const swiperCards = new Swiper('.slider-cards.swiper-container', {
	// init: false,
	slidesPerView: 1,
	spaceBetween: 50,
	breakpoints: {
		768: {
			slidesPerView: 2,
		},
		992: {
			slidesPerView: 3,
		}
	},
	navigation: {
		nextEl: '.slider-nav-next',
		prevEl: '.slider-nav-prev',
	},
	on: {
		init: function() {
			const numberOfSlides = this.slides.length;
			console.log(numberOfSlides);
			// if (numberOfSlides > 1) {
			// 	this.init();
			// }
		}
	}
});
